module.exports = __webpack_public_path__ + "static/assets/8fdfdb6cfef20432592f7095a8ad4bfd.svg";